import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=4a967b82&scoped=true&"
import script from "./ProductTable.vue?vue&type=script&lang=js&"
export * from "./ProductTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductTable.vue?vue&type=style&index=0&id=4a967b82&prod&lang=css&"
import style1 from "./ProductTable.vue?vue&type=style&index=1&id=4a967b82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a967b82",
  null
  
)

export default component.exports